var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "defaultscroll sticky",
    attrs: {
      "id": "topnav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('b-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/logo/logo.svg"),
      "height": "50",
      "alt": "BrevisVelox.com"
    }
  })])], 1), _c('div', {
    attrs: {
      "id": "navigation"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }